import React, { useCallback, useState, useEffect } from 'react';
import { Metrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import { EmailFormView } from './EmailFormView';
import { PasswordFormView } from './PasswordFormView';

/**
 *
 * @param {string} facebookLoginUrl
 * @param {string} googleLoginUrl
 * @param {string} appleLoginUrl
 * @param {function} trackClickFacebookLogin
 * @param {function} trackClickGoogleLogin
 * @param {function} trackClickAppleLogin
 * @param {function} trackClickSignUp
 * @param {string} returnUrl
 * @param {boolean} rememberMe
 * @param {boolean} showRememberMe
 * @param {function} sendMetric
 * @param {string} className
 * @returns {JSX.Element}
 */
export const EmailFirstSignInFormView = ({
    facebookLoginUrl,
    googleLoginUrl,
    appleLoginUrl,
    trackClickFacebookLogin,
    trackClickGoogleLogin,
    trackClickAppleLogin,
    trackClickSignUp,
    returnUrl,
    rememberMe,
    showRememberMe,
    isInMobileMenu = false,
    className,
    ...props
}) => {
    useEffect(() => {
        if (props.signedIn && isInMobileMenu) {
            window.location.replace(returnUrl || props.suggestedRedirect);
        }
    }, [returnUrl, props.signedIn, props.suggestedRedirect, isInMobileMenu]);

    const [hasProvidedEmail, setHasProvidedEmail] = useState(false);
    const [email, setEmail] = useState(null);

    const onSubmitEmail = useCallback((email) => {
        setEmail(email);
        setHasProvidedEmail(true);
    }, []);

    const onEditEmailClick = () => {
        setHasProvidedEmail(false);
        setEmail(null);
    };

    const FormView = hasProvidedEmail ? (
        <PasswordFormView
            {...props}
            email={email}
            trackClickSignUp={trackClickSignUp}
            rememberMe={rememberMe}
            showRememberMe={showRememberMe}
            onEditEmailClick={onEditEmailClick}
        />
    ) : (
        <EmailFormView
            facebookLoginUrl={facebookLoginUrl}
            googleLoginUrl={googleLoginUrl}
            appleLoginUrl={appleLoginUrl}
            trackClickFacebookLogin={trackClickFacebookLogin}
            trackClickGoogleLogin={trackClickGoogleLogin}
            trackClickAppleLogin={trackClickAppleLogin}
            trackClickSignUp={trackClickSignUp}
            returnUrl={returnUrl}
            rememberMe={rememberMe}
            showRememberMe={showRememberMe}
            onSubmitEmail={onSubmitEmail}
        />
    );

    return (
        <div className={className} data-test="email-first-sign-in-form">
            <Metrics category={'EmailFirstSignInForm'}>{FormView}</Metrics>
        </div>
    );
};
